import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=51396294"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51396294')) {
      api.createRecord('51396294', component.options)
    } else {
      api.reload('51396294', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=51396294", function () {
      api.rerender('51396294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/Email.vue"
export default component.exports